import { atom, useRecoilState } from "recoil";

const counterFilesState = atom({
    key: 'counterFiles',
    default: []
});

export default function useCounterFiles() {
    const [counterFiles, setCounterFiles] = useRecoilState(counterFilesState);

    // Ensure counterFiles is always an array
    const safeCounterFiles = Array.isArray(counterFiles) ? counterFiles : [];

    const addCounterFile = (file) => {
        const alreadyAdded = safeCounterFiles.some(f => f.guid === file.guid);
        if (!alreadyAdded) {
            setCounterFiles(prev => {
                const safePrev = Array.isArray(prev) ? prev : [];
                return [...safePrev, file];
            });
        }
    }

    const removeCounterFile = (file) => {
        setCounterFiles(prev => {
            const safePrev = Array.isArray(prev) ? prev : [];
            return safePrev.filter((f) => f.guid !== file.guid);
        });
    }

    const clearCounterFiles = () => {
        setCounterFiles([]);
    };

    return {
        counterFiles: safeCounterFiles,
        addCounterFile,
        removeCounterFile,
        clearCounterFiles
    };
}